class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.productVariants = this.querySelectorAll('[data-variant]');

    this.productVariants?.forEach(variant => variant.addEventListener('click', (event) => this.onChangeVariant(event)));
  }

  onChangeVariant(event) {
    event.preventDefault();
    this.productVariant = event.currentTarget;

    // Change product card anchors
    this.productVariantUrl = this.productVariant.href;
    this.productAnchors = this.querySelectorAll('[data-product-anchor]');

    this.productAnchors.forEach(productAnchor => {
      productAnchor.href = this.productVariantUrl;
    });

    // Change product card images
    this.productVariantImageUrl = this.productVariant.dataset.variantImageUrl;
    this.productImage = this.querySelector('img');
    this.productPicture = this.querySelector('[data-product-picture]');
    this.productPictureSources = this.productPicture.querySelectorAll('source');

    this.productImage.src = this.productVariantImageUrl
    this.productImage.srcset = this.productVariantImageUrl

    this.productPictureSources.forEach(productPictureSource => {
      productPictureSource.srcset = this.productVariantImageUrl
    });

    this.productVariants.forEach(productVariant => {
      productVariant.classList.remove('swatches__swatch-label--checked');
    });

    event.currentTarget.classList.add('swatches__swatch-label--checked');
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}

class ProductCardSwiper extends HTMLElement {
  constructor() {
    super();

    let windowWidth = window.innerWidth;
    this.swiperElement = this.querySelector('[data-swiper-product-card]');

    this.swiperOptions = {
      watchOverflow: true,
      preventClicks: true,
      loop: false,
      autoplay: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      slidesPerView: 1,
      direction: 'horizontal'
    }

    // Check if we have extra options on the HTML
    if (this && this.dataset && this.dataset.options) {
      const jsonOptions = JSON.parse(this.dataset.options);

      if (jsonOptions) {
        this.swiperOptions = {
          ...this.swiperOptions,
          ...jsonOptions
        };
      }
    }

    window.addEventListener('load', () => {
      if (windowWidth < 768) {
        this.init();
        this.querySelectorAll('button').forEach(button => button.classList.remove('hidden'));
      }
    });

    window.addEventListener('resize', () => {
      windowWidth = window.innerWidth;
      if (windowWidth < 768) {
        this.init();
        this.querySelectorAll('button').forEach(button => button.classList.remove('hidden'));
      }
    });
  }

  init() {
    this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
  }
}

if(!customElements.get('product-card-swiper')) {
  customElements.define('product-card-swiper', ProductCardSwiper);
}


